/* YUN-53: enhance only phone PDPs; desktop DOM is restored on resize. */
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const tr = document.documentElement.lang.startsWith('tr');
  const addLabel = tr ? 'Ekle' : 'Add';
  class MobileProduct {
    constructor(root, {preview = false} = {}) {
      this.root = root;
      this.preview = preview;
      this.gallery = root.querySelector('[data-gap-gallery]');
      this.frames = [...(this.gallery?.querySelectorAll('.gap__frame') || [])];
      this.variants = JSON.parse(root.querySelector('[data-gap-variants]')?.textContent || '[]');
      if (!this.frames.length || !this.variants.length) return;
      this.onChange = () => mobile.matches ? this.mount() : this.unmount();
      mobile.addEventListener('change', this.onChange);
      this.onChange();
    }
    move(node, destination) {
      if (!node) return;
      const marker = document.createComment('mobile-product-origin');
      node.before(marker);
      this.moves.push({node, marker});
      destination.append(node);
    }
    button(text, className) {
      const b = document.createElement('button'); b.type = 'button'; b.className = className; b.textContent = text;
      return b;
    }
    mount() {
      if (this.summary || !this.root.isConnected) return;
      this.abort = new AbortController(); this.moves = [];
      const signal = this.abort.signal;
      this.root.classList.add('gap--mobile-editorial');
      if (!this.preview) document.body.classList.add('giesto-mobile-pdp');
      this.summary = document.createElement('div'); this.summary.className = 'gmp-summary';
      this.frames[0].after(this.summary);
      const heading = document.createElement('div'); heading.className = 'gmp-heading'; this.summary.append(heading);
      this.move(this.root.querySelector('.gap__title'), heading);
      this.move(this.root.querySelector('.gap__price'), heading);
      this.move(this.root.querySelector('.gap__campaign-price'), heading);
      this.move(this.root.querySelector('.gap__unit-price'), heading);
      this.move(this.root.querySelector('.gap__campaigns'), this.summary);
      // YUN-189: on phones the campaign row opens a sheet from below, like the sizes.
      const campaignRow = this.summary.querySelector('.gap__campaigns-summary');
      // Inside this product only: an inert neighbour preview has no sheet of its own.
      const campaignSheet = this.root.querySelector('theme-drawer#GiestoCampaignSheet');
      if (campaignRow && campaignSheet) {
        campaignRow.setAttribute('aria-haspopup', 'dialog');
        campaignRow.addEventListener('click', event => {
          event.preventDefault();
          if (typeof campaignSheet.open !== 'function') customElements.upgrade(campaignSheet);
          if (typeof campaignSheet.open === 'function') campaignSheet.open();
          else customElements.whenDefined('theme-drawer').then(() => {customElements.upgrade(campaignSheet); campaignSheet.open?.();});
        }, {signal});
      }
      this.move(this.root.querySelector('.gap__pack-options'), this.summary);
      this.color = this.button(tr ? 'Renk' : 'Color', 'gmp-color'); heading.append(this.color);
      this.move(this.root.querySelector('.gap__buy .gap__wish'), heading);
      this.source = this.summary; this.source.dataset.gsSizeSource = '';
      this.payload = document.createElement('script'); this.payload.type = 'application/json'; this.payload.dataset.gacVariants = ''; this.source.append(this.payload);
      this.add = this.button(addLabel, 'gap__add gmp-add'); this.source.append(this.add);
      this.add.hidden = this.root.dataset.comingSoon === 'true';
      if (this.add.hidden) this.move(this.root.querySelector('.giesto-product-reminder'), this.source);
      this.add.dataset.gacSizeTrigger = '';
      this.add.dataset.gacReminders = '';
      this.add.dataset.productHandle = this.root.dataset.productHandle;
      this.add.dataset.mobileProductBuy = '';
      this.add.dataset.productId = this.root.dataset.productId;
      this.add.dataset.productTitle = heading.querySelector('h1')?.textContent.trim() || '';
      this.add.dataset.productUrl = location.pathname;
      const sizeOption = this.root.querySelector('.gap__option [data-gap-option]');
      this.add.dataset.sizePosition = sizeOption?.dataset.optionPosition || '0';
      this.add.addEventListener('click', () => this.openSizes(this.add), {signal});
      this.tabs = document.createElement('div'); this.tabs.className = 'gmp-tabs'; this.gallery.insertBefore(this.tabs, this.summary.nextSibling);
      const list = document.createElement('div'); list.className = 'gmp-tab-list'; list.setAttribute('role', 'tablist'); list.setAttribute('aria-label', tr ? 'Ürün bilgileri' : 'Product information'); this.tabs.append(list);
      this.panels = new Map(); this.buttons = [];
      this.stock = this.root.querySelector('[data-giesto-galata]');
      // YUN-217: colours come first and open by default, before the description.
      const labels = tr ? ['Renk', 'Açıklama', 'Malzemeler', 'Ölçüler', 'Teslimat'] : ['Color', 'Description', 'Materials', 'Measurements', 'Delivery'];
      const keys = ['color','details','materials','measurements','shipping'];
      if (this.stock) { keys.push('stock'); labels.push(this.stock.dataset.giestoGalataTabLabel || (tr ? 'Stok durumu' : 'Store availability')); }
      keys.forEach((key, index) => {
        const button = this.button(labels[index], 'gmp-tab');
        button.dataset.gmpTab = key;
        const id = `${this.root.id}-mobile-${key}`;
        button.id = id+'-tab'; button.setAttribute('role','tab'); button.setAttribute('aria-controls',id);
        list.append(button); this.buttons.push(button);
        const panel = document.createElement('div'); panel.id = id; panel.className = 'gmp-panel'; panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',button.id); panel.tabIndex = 0; this.tabs.append(panel); this.panels.set(key,panel);
        if (key === 'stock') {
          this.stockDisclosure = this.stock.querySelector('[data-giesto-galata-disclosure]');
          if (this.stockDisclosure) {
            this.stockWasOpen = this.stockDisclosure.open;
            this.stockDisclosure.open = true;
          }
          this.move(this.stock, panel);
          button.hidden = this.stock.hidden;
        } else if (!['color','measurements'].includes(key)) this.copyContent(this.root.querySelector(`[data-gaa-sheet="${key}"] .gaa__sheet-content`), panel);
        button.addEventListener('click', () => this.selectTab(key), {signal});
        button.addEventListener('keydown', e => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
          e.preventDefault();
          const visible = this.buttons.filter(item => !item.hidden);
          const next = e.key === 'Home' ? 0 : e.key === 'End' ? visible.length-1 : (visible.indexOf(button)+(e.key === 'ArrowRight' ? 1 : -1)+visible.length)%visible.length;
          visible[next].click(); visible[next].focus();
        }, {signal});
      });
      this.prepareDescription();
      for (const key of this.panels.keys()) this.preparePanel(key);
      this.color.addEventListener('click', () => {this.selectTab('color'); this.tabs.scrollIntoView({block:'start',behavior:'smooth'});}, {signal});
      this.dock = document.createElement('div'); this.dock.className = 'gmp-dock is-inactive'; this.dock.dataset.gsSizeSource = ''; this.root.append(this.dock);
      this.dockPayload = this.payload.cloneNode(); this.dock.append(this.dockPayload);
      this.dockAdd = this.button(addLabel, 'gap__add gmp-add'); this.dockAdd.dataset.gacSizeTrigger = ''; this.dock.append(this.dockAdd);
      this.dockAdd.dataset.mobileProductBuy = '';
      for (const key of ['productId','productTitle','productUrl','sizePosition','productHandle','gacReminders']) this.dockAdd.dataset[key] = this.add.dataset[key];
      this.dockPrice = document.createElement('span'); this.dockPrice.className = 'gmp-dock-price'; this.dock.append(this.dockPrice);
      this.dockAdd.addEventListener('click', () => this.openSizes(this.dockAdd), {signal});
      this.root.addEventListener('giesto:variant-change', () => {this.updateVariants(); this.updatePrice();}, {signal});
      this.root.addEventListener('giesto:galata-change', () => this.updateStockTab(), {signal});
      this.observer = new MutationObserver(() => {this.updateColor(); this.updatePrice();});
      for (const element of this.root.querySelectorAll('[data-gap-colour-groups], [data-gap-native-colors], [data-gaa-single-color], .gap__price')) this.observer.observe(element,{childList:true,subtree:true,attributes:true});
      this.schedule = () => {if (!this.raf) this.raf = requestAnimationFrame(() => {this.raf = 0; this.updateDock();});};
      window.addEventListener('scroll',this.schedule,{passive:true,signal}); window.addEventListener('resize',this.schedule,{passive:true,signal});
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.gallery);
      this.updateVariants(); this.updatePrice(); this.updateColor(); this.selectTab('color'); this.updateDock();
      this.updateStockTab();
      if (!this.preview) document.documentElement.classList.remove('giesto-mobile-product-pending');
    }
    copyContent(source, target) {
      target = target.querySelector('.gmp-panel-content') || target;
      target.replaceChildren();
      if (!source) return;
      const copy = source.cloneNode(true);
      for (const e of [copy,...copy.querySelectorAll('[id]')]) e.removeAttribute('id');
      target.append(...copy.childNodes);
    }
    prepareDescription() {
      const panel = this.panels.get('details');
      for (const disclosure of panel.querySelectorAll('.gaa__disclosure')) {
        const section = document.createElement('section');
        const heading = document.createElement('h3');
        heading.textContent = disclosure.querySelector('summary')?.firstChild?.textContent.trim() || '';
        section.append(heading);
        const body = disclosure.querySelector('summary')?.nextElementSibling;
        if (body) section.append(body);
        this.panels.get('shipping').append(section); disclosure.remove();
      }
      const description = panel.querySelector('.gaa__description');
      if (!description) return;
      const numberHeading = panel.querySelector('h3');
      const number = numberHeading?.nextElementSibling;
      if (number?.tagName === 'P') {
        number.className = 'gmp-reference';
        number.textContent = `${numberHeading.textContent.trim()}: ${number.textContent.trim()}`;
        panel.append(number); numberHeading.remove();
      }
    }
    preparePanel(key) {
      const panel = this.panels.get(key);
      const content = document.createElement('div'); content.className = 'gmp-panel-content';
      content.id = panel.id+'-content'; content.append(...panel.childNodes); panel.append(content);
      if (['measurements','color','stock'].includes(key)) {content.classList.add('is-expanded'); return;}
      const preview = document.createElement('div'); preview.className = 'gmp-panel-preview';
      preview.textContent = (content.querySelector('.gaa__description') || content).textContent.trim().replace(/\s+/g,' ');
      content.hidden = true; content.before(preview);
      const toggle = this.button(tr ? 'Devamını oku' : 'Read more', 'gmp-read-more');
      toggle.setAttribute('aria-controls',content.id); toggle.setAttribute('aria-expanded','false'); panel.append(toggle);
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded',String(expanded)); content.classList.toggle('is-expanded',expanded);
        content.hidden = !expanded; preview.hidden = expanded;
        toggle.textContent = expanded ? (tr ? 'Daha az göster' : 'Read less') : (tr ? 'Devamını oku' : 'Read more');
        this.updatePanelFocus(content, expanded);
        this.schedule();
      }, {signal:this.abort.signal});
    }
    updatePanelFocus(content, expanded) {
      this.panelTabIndexes ||= new WeakMap();
      for (const element of content.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')) {
        if (!this.panelTabIndexes.has(element)) this.panelTabIndexes.set(element,element.getAttribute('tabindex'));
        const index = this.panelTabIndexes.get(element);
        if (!expanded) element.setAttribute('tabindex','-1');
        else if (index === null) element.removeAttribute('tabindex');
        else element.setAttribute('tabindex',index);
      }
    }
    updateStockTab() {
      const button = this.buttons.find(item => item.dataset.gmpTab === 'stock');
      if (!button) return;
      button.hidden = this.stock.hidden;
      if (button.hidden && this.activeTab === 'stock') {
        const focused = this.tabs.contains(document.activeElement);
        this.selectTab('color');
        if (focused) this.buttons[0].focus({preventScroll:true});
      }
      this.schedule?.();
    }
    selectTab(key) {
      if (key === 'color') this.copyColors();
      if (key === 'measurements') {
        const guide = this.root.closest('.shopify-section')?.querySelector('.gs-size-guide__content');
        this.copyContent(guide, this.panels.get(key));
        const copy = this.panels.get(key);
        copy.querySelector('.gs-size-guide__how-to-measure')?.remove();
        const content = copy.querySelector('.gmp-panel-content');
        if (!content.textContent.trim()) content.textContent = tr ? 'Bu ürünün beden ölçüleri henüz eklenmedi.' : 'Measurements are not yet available for this product.';
      }
      [...this.panels].forEach(([name,panel],i) => {
        const active = name === key; panel.hidden = !active;
        const content = panel.querySelector('.gmp-panel-content');
        const toggle = panel.querySelector('.gmp-read-more');
        if (toggle) toggle.hidden = !content.textContent.trim() && !content.querySelector('img');
        this.updatePanelFocus(content,content.classList.contains('is-expanded'));
        this.buttons[i].setAttribute('aria-selected',String(active)); this.buttons[i].tabIndex = active ? 0 : -1;
      });
      this.activeTab = key;
      this.schedule?.();
    }
    copyColors() {
      const native = this.root.querySelector('[data-gaa-sheet="native-colors"] .gaa__sheet-content');
      const family = this.root.querySelector('.gap__colour-groups-drawer-content');
      const source = family?.querySelector('a') && !this.root.querySelector('[data-gap-colour-groups-trigger]')?.hidden ? family : native || this.root.querySelector('[data-gaa-single-color]');
      this.copyContent(source, this.panels.get('color'));
      for (const image of this.panels.get('color').querySelectorAll('img')) {
        const url = new URL(image.src, location.origin);
        if (url.pathname.includes('/cdn/shop/') || url.hostname === 'cdn.shopify.com') {
          url.searchParams.set('width','120'); image.src = url.href;
          image.removeAttribute('srcset'); image.loading = 'lazy'; image.decoding = 'async';
        }
      }
      const content = this.panels.get('color').querySelector('.gmp-panel-content');
      this.updatePanelFocus(content,content.classList.contains('is-expanded'));
    }
    updateColor() {
      const trigger = [...this.root.querySelectorAll('.gap__colour-summary')].find(e => !e.hidden);
      const single = this.root.querySelector('[data-gaa-single-color]');
      const label = (trigger?.textContent || single?.textContent || (tr ? 'Renk' : 'Color')).trim();
      this.color.replaceChildren();
      const count = label.match(/\+\s*(\d+)/)?.[1];
      if (count) this.color.append(document.createTextNode('+'+count));
      const swatch = (trigger || single)?.querySelector('.gap__colour-swatch, span[style]');
      if (swatch) this.color.append(swatch.cloneNode(true));
      if (!swatch) this.color.append(document.createTextNode(label));
      this.color.setAttribute('aria-label', `${tr ? 'Renk' : 'Color'}: ${label}`);
      if (this.activeTab === 'color') this.copyColors();
    }
    updatePrice() {this.dockPrice.textContent = this.summary.querySelector('[data-gap-price-value]')?.textContent.trim() || '';}
    updateVariants() {
      // Native colours must not allow a size picker to silently select another colour.
      const position = Number(this.root.dataset.colourPosition);
      const selected = this.root.querySelector(`[data-gap-option][data-option-position="${position}"][data-selected="true"]`)?.dataset.optionValue || JSON.parse(this.root.dataset.selectedOptions || '[]')[position];
      this.filtered = position >= 0 && selected ? this.variants.filter(v => v.options[position] === selected) : this.variants;
      this.payload.textContent = this.dockPayload.textContent = JSON.stringify(this.filtered);
      const unavailable = !this.filtered.some(v => v.available);
      for (const button of [this.add,this.dockAdd]) {
        button.disabled = this.root.dataset.comingSoon === 'true';
        if (unavailable) {
          const icon = document.querySelector('[data-reminder-bell-template]');
          button.replaceChildren();
          if (icon instanceof HTMLTemplateElement) button.append(icon.content.cloneNode(true));
          button.append(document.createTextNode(document.querySelector('[data-reminder-config]')?.dataset.reminderIdle || this.root.dataset.labelSoldOut));
        } else button.textContent = addLabel;
      }
    }
    openSizes(trigger) {
      this.updateVariants();
      if (trigger.disabled) return;
      // The shared delegated [data-gac-size-trigger] handler takes this click.
      // Opening here would make its outside-click handler close the sheet again.
    }
    setBarActive(bar, active) {
      bar.classList.toggle('is-inactive', !active);
      bar.inert = !active;
      bar.setAttribute('aria-hidden', String(!active));
    }
    updateDock() {
      const end = this.frames.at(-1).getBoundingClientRect().bottom;
      const height = this.dock.offsetHeight || 64;
      const atStart = this.preview || scrollY <= 24;
      this.setBarActive(this.summary, atStart);
      this.root.toggleAttribute('data-mobile-start',atStart);
      this.tabs.inert = atStart;
      this.setBarActive(this.dock, this.root.dataset.comingSoon !== 'true' && !atStart && end > innerHeight-height && this.frames[0].getBoundingClientRect().top < innerHeight);
    }
    unmount() {
      if (!this.summary) return;
      this.abort.abort(); this.observer.disconnect(); this.resizeObserver.disconnect(); cancelAnimationFrame(this.raf);
      for (const {node,marker} of this.moves) {marker.replaceWith(node);}
      this.root.querySelector('.gap__campaigns-summary')?.removeAttribute('aria-haspopup');
      const campaignSheet = this.root.querySelector('theme-drawer#GiestoCampaignSheet');
      if (campaignSheet?.hasAttribute('open')) campaignSheet.close?.();
      if (this.stockDisclosure) this.stockDisclosure.open = this.stockWasOpen;
      this.summary.remove(); this.tabs.remove(); this.dock.remove();
      if (!this.preview) document.body.classList.remove('giesto-mobile-pdp');
      this.root.removeAttribute('data-mobile-start');
      this.root.classList.remove('gap--mobile-editorial'); this.summary = null;
    }
  }
  // Inert adjacent panels use the same presentation as the real product;
  // their controls never run and the destination still loads normally.
  window.GiestoMobileProductPreview = root => {
    const stock = root.querySelector('[data-giesto-galata]');
    if (stock && window.GiestoGalataStok) {
      try {
        const data = JSON.parse(stock.querySelector('[data-giesto-galata-data]')?.textContent || 'null');
        const selection = JSON.parse(root.dataset.selectedOptions || '[]');
        const state = window.GiestoGalataStok.galataState(data, selection, Number(root.dataset.colourPosition), Date.now());
        const text = window.GiestoGalataStok.galataText(data?.labels,state);
        stock.querySelector('[data-giesto-galata-line]').textContent = text;
        stock.querySelector('[data-giesto-galata-body]').hidden = !text;
        stock.hidden = !text;
      } catch { /* Missing stock data stays hidden, as on the real page. */ }
    }
    const container = root.querySelector('[data-gap-colour-groups] .csga-pc');
    const cache = window.CSGA?.PC?.m;
    if (container && cache && window.GiestoColorGroups) {
      const record = cache.get(container.dataset.p) || [...cache.values()].find(group=>group?.products?.some(product=>String(product.id).split('/').at(-1)===container.dataset.p));
      const group = window.GiestoColorGroups.match(container,record);
      const current = group.products.find(product=>String(product.id).split('/').at(-1)===container.dataset.p);
      const trigger = root.querySelector('[data-gap-colour-groups-trigger]');
      if (current && trigger && group.products.length>1) {
        trigger.hidden = false;
        trigger.querySelector('.gap__colour-label').textContent = `${current.color} +${group.products.length-1}`;
        trigger.querySelector('.gap__colour-swatch').style.backgroundColor = current.colorCode || '#888';
      }
    }
    const view = new MobileProduct(root, {preview:true});
    return () => { view.unmount(); mobile.removeEventListener('change', view.onChange); };
  };
  const initialize = () => document.querySelectorAll('giesto-store-product.gap--reference').forEach(root => {if (!root.mobileProduct) root.mobileProduct = new MobileProduct(root);});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
